module.exports = ".time-picker-button {\n  padding: 0;\n  margin: 0;\n  min-width: 44px; }\n"